import React from "react"
import './banner.scss'
import {
  DownOutlined
} from '@ant-design/icons';




class Banner extends React.Component {
  constructor(props) {
    super(props)
    this.sliderRef = React.createRef();
    this.imgRef = React.createRef()
  }

  state = {
  }

  componentDidMount() {

  }


  render() {
    return (
        <div className={"banner-panel"}>
            <div className="banner-shadow">
              <div className="wrapper">
                <img src="http://img.uigreat.com/sz/pxferlogo.png" alt="" />
                <div className="banner-title1">每秒一像素，奔向梦想</div>
                <div className="banner-title2">深圳像素范儿UI设计线下全日培训</div>
                <div className="banner-btn-panel">
                  <div className="banner-btn" onClick={() => {
                    document.querySelector("#apply").scrollIntoView({ behavior: 'smooth' });
                  }}>立即报名</div>
                  <div className="banner-btn banner-btn-white"  onClick={() => {
                    document.querySelector("#outline").scrollIntoView({ behavior: 'smooth' });
                  }}>了解详情</div>
                </div>
              </div>
            </div>
            <div className="one-page-arrow" onClick={() => {
              document.querySelector("#outline").scrollIntoView({ behavior: 'smooth' });
            }}>
              <img src="https://img.uigreat.com/szpxfer/down-arrow.png" alt=""/>
            </div>
        </div>
    )
  }

}
export default Banner